import React, { useState } from "react";
import HeroImg from "../../Shared components/HeroImg";
import { useNavigate, useParams } from "react-router-dom";
import { MdArrowBackIosNew } from "react-icons/md";
import { Eye, EyeOff } from "lucide-react";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { Config } from "../../API/config";

const Reseting = () => {
    let email = useParams().email || ""
    const [viewPassword, setViewPassword] = useState(false);
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);


    const navigate = useNavigate();

    const handleViewPass = () => {
        setViewPassword(!viewPassword);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        // Validate Password
        if (!password.trim()) {
            toast.error("يرجى إدخال كلمة السر الجديدة");
            return;
        }
        if (password.length < 6) {
            toast.error("يجب أن تكون كلمة السر 6 أحرف على الأقل");
            return;
        }

        try {
            setLoading(true);
            const data = await axios.post(
                Config.resetPassword,
                { email,password },
                { withCredentials: true }
            );

            if (data.data.statusCode === 201) {
                toast.success("تم تغيير كلمة المرور بنجاح");
                navigate("/login"); // Redirect to login
            } else {
                toast.error(data.data.message || "حدث خطأ أثناء تغيير كلمة المرور");
            }
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {

                
                toast.error(error.response.data.message || "حدث خطأ، حاول مرة أخرى");
            } else {
                toast.error("خطأ غير متوقع، حاول لاحقًا");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
        <Toaster/>
        <div className="flex flex-row min-h-screen w-full">
            <HeroImg />
            <div className="flex flex-col items-end justify-start w-full mt-10 px-24 relative">
                <button onClick={() => navigate(-1)}>
                    <div className="w-[40px] h-[40px] border absolute top-0 left-0 cursor-pointer ml-6 border-neutral-800 rounded-full flex justify-center items-center hover:bg-primary-100 transition-all duration-150 group">
                        <MdArrowBackIosNew
                            size={22}
                            color="#4a4a4a"
                            fontWeight={200}
                            className="text-neutral-900 group-hover:translate-x-[-2px] group-hover:fill-white transition-transform duration-150"
                        />
                    </div>
                </button>
                <div className="w-full">
                    <div className="w-full flex justify-end">
                        <h2 className="text-[32px] leading-[67.58px] font-[500] text-neutral-900">
                            Otlob Coach مرحباً بكم في
                        </h2>
                    </div>
                    <div className="w-full flex justify-end">
                        <p className="text-[16px] leading-[24px] font-[400] text-neutral-900">
                            اعادة تعيين كلمة السر
                        </p>
                    </div>
                    <div className="w-full my-3 mt-6">
                        <form onSubmit={handleSubmit}>
                            <label htmlFor="password" className="block mb-2 text-sm font-medium text-neutral-600 text-right">
                                كلمة السر الجديدة
                            </label>
                            <div className="flex text-right border border-gray-300 text-neutral-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 w-full p-4">
                                <input
                                    className="bg-none focus:outline-none w-full text-right rtl order-2"
                                    type={viewPassword ? "text" : "password"}
                                    name="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                {viewPassword ? (
                                    <Eye className="cursor-pointer order-1" onClick={handleViewPass} />
                                ) : (
                                    <EyeOff className="cursor-pointer order-1" onClick={handleViewPass} />
                                )}
                            </div>
                            <div className="w-full my-5 flex justify-center">
                                <button
                                    type="submit"
                                    className="bg-white text-primary-500 p-3 w-full mt-5 border rounded-md border-primary-500 md:w-[158px] hover:bg-primary-500 hover:text-white hover:border-transparent transition-all duration-500"
                                    disabled={loading}
                                >
                                    {loading ? "جاري التحديث..." : "تغيير كلمة السر"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default Reseting;
